// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"Loader_ldsEllipsis__JvkMN","ldsEllipsis1":"Loader_ldsEllipsis1__viXPz","ldsEllipsis2":"Loader_ldsEllipsis2__-DJDG","ldsEllipsis3":"Loader_ldsEllipsis3__yfSt-"};